<div *ngIf="activePersons || inactivePersons" class="card" xmlns="http://www.w3.org/1999/html">
  <div class="card-header">
    Personen
  </div>
  <div class="card-block">
    <clr-datagrid *ngIf="activePersons">

      <clr-dg-column [clrDgField]="'lastname'" [clrDgSortOrder]="descSort">Name (aktiv)</clr-dg-column>
      <clr-dg-column>Position</clr-dg-column>
      <clr-dg-column>Kontakt</clr-dg-column>

      <clr-dg-placeholder>Keine aktive Person gefunden!</clr-dg-placeholder>
      <clr-dg-row *clrDgItems="let person of activePersons">
        <clr-dg-cell [routerLink]="['/person/details', person.pid ]">{{ person.lastname }} <span *ngIf="person.firstname">, {{ person.firstname }}</span></clr-dg-cell>
        <clr-dg-cell>{{ person.position}}</clr-dg-cell>
        <clr-dg-cell>
          <span *ngIf="person.phone" (click)="makeACall = true; callTarget = person.phone; callFirstname = person.firstname; callLastname = person.lastname"><br /> {{ person.phone }}</span>
          <span *ngIf="person.mobile" (click)="makeACall = true; callTarget = person.mobile; callFirstname = person.firstname; callLastname = person.lastname"><br /> {{ person.mobile }}</span>
          <span *ngIf="person.email"><br /> {{ person.email }}</span>
          <span *ngIf="person.email2"><br /> {{ person.email2 }}</span>
          <span *ngIf="person.email3"><br /> {{ person.email3 }}</span>
        </clr-dg-cell>
      </clr-dg-row>

      <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="20">
          {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
          von {{activePersons.length}} Person(en)
        </clr-dg-pagination>
      </clr-dg-footer>
    </clr-datagrid>

    <clr-datagrid *ngIf="inactivePersons">

      <clr-dg-column [clrDgField]="'lastname'" [clrDgSortOrder]="descSort">Name (deaktiviert)</clr-dg-column>
      <clr-dg-column>Position</clr-dg-column>
      <clr-dg-column>Kontakt</clr-dg-column>

      <clr-dg-placeholder>Keine deaktivierten Person gefunden!</clr-dg-placeholder>
      <clr-dg-row *clrDgItems="let person of inactivePersons">
        <clr-dg-cell [routerLink]="['/person/details', person.pid ]">{{ person.firstname }} {{ person.lastname }}</clr-dg-cell>
        <clr-dg-cell>{{ person.position}}</clr-dg-cell>
        <clr-dg-cell>
          <span *ngIf="person.phone" (click)="makeACall = true; callTarget = person.phone; callFirstname = person.firstname; callLastname = person.lastname"><br /> {{ person.phone }}</span>
          <span *ngIf="person.mobile" (click)="makeACall = true; callTarget = person.mobile; callFirstname = person.firstname; callLastname = person.lastname"><br /> {{ person.mobile }}</span>
          <span *ngIf="person.email"><br /> {{ person.email }}</span>
          <span *ngIf="person.email2"><br /> {{ person.email2 }}</span>
          <span *ngIf="person.email3"><br /> {{ person.email3 }}</span>
        </clr-dg-cell>
      </clr-dg-row>

      <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="20">
          {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
          von {{inactivePersons.length}} Person(en)
        </clr-dg-pagination>
      </clr-dg-footer>
    </clr-datagrid>
  </div>
  <div class="card-footer">
    <button *ngIf="!devMode" class="btn btn-sm btn-link" [routerLink]="['/person/add', companyId] ">Person hinzufügen</button>
  </div>
</div>

<clr-modal *ngIf="activePersons" [(clrModalOpen)]="makeACall" [clrModalStaticBackdrop]="false">
  <h3 class="modal-title">Möchten Sie {{ callFirstname }} {{ callLastname }} anrufen?</h3>
  <div class="modal-body">
    <p><a [attr.href]="callUrl(callTarget)">{{ callTarget }}</a></p>
    <small>(Anruf wird an Telefonanlage übergeben)</small>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="makeACall = false">Abbrechen</button>
    <button type="button" class="btn btn-primary" (click)="startCall(callTarget)">JETZT ANRUFEN</button>
  </div>
</clr-modal>
